var _path, _path2, _path3, _polygon, _polygon2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-14",
    cx: 250,
    cy: 343.2,
    rx: 236.99,
    ry: 131.73,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-14",
    d: "M180.83,357.05c-39.63,22.88-39.63,60,0,82.85s103.88,22.88,143.5,0,39.63-60,0-82.85S220.45,334.17,180.83,357.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M81.47,256.82c-31.4,18.13-31.4,47.52,0,65.65s82.3,18.12,113.69,0,31.4-47.52,0-65.65S112.86,238.7,81.47,256.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M165.88,321.11c-18,10.37-18,27.19,0,37.56s47.09,10.37,65.05,0,18-27.18,0-37.56S183.85,310.74,165.88,321.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M316,314.42c3.12,1.75,19.75,9.27,38.62,2.89s26-18.26,36.49-23.65,21.74-8.59,28.32-12.39-.7-6.48-9.81-7.3-17.2,3.13-24.82.13-36.51-12.79-55.17-4.89S292.29,293,292.19,298.56c-.1,5.84,8.67,10.47,18.71,10.8A15.63,15.63,0,0,0,316,314.42Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.11,289.64c-6.83,4.18-12.1,9.79-19.43,14-17.95,10.25-27,10.88-37.51,8.9l19.53-19.26s29-12.08,31.57-14.19c2.17-1.77,2.26-6.22,5.27-6.94,3.47-.83,5.95,1,8.18,3.08s4.87,2.82,10.07,1,10.22-4.35,12.33-3.34.7,2.65-8.4,6.85c-5.22,2.41-11.8,5.43-16.14,6.9-2.76.94-7.9,4.7-10.38,6.22",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.71,273.6c1-1.35-2.18-4.91-7.9-5.55a22.45,22.45,0,0,0-10.59,1.27c-2.92,1-6.81,1.13-9.26,0-4.45-2.07-5.93-1.62-5.69,1.25,0,0-.6,3.21,3.17,4.55S410.24,276.15,418.71,273.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,278.52c1.9,3.27,6.31,2.3,10,1.6,3.49-.66,16.24-4.08,17.92-1.58,3.47-1.34,6.89-3.25,8.48-4.94,0,0-.92-3.51-8.13-1.78-4.71,1.13-13.34,1.72-16,1.39-3.49-.43-8.23-3.59-11.86-2.14C381.16,273.24,381.8,275.36,382.28,278.52Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,278.52c1.9,3.27,6.31,2.3,10,1.6,3.49-.66,16.24-4.08,17.92-1.58,3.47-1.34,6.89-3.25,8.48-4.94,0,0-.92-3.51-8.13-1.78-4.71,1.13-13.34,1.72-16,1.39-3.49-.43-8.23-3.59-11.86-2.14C381.16,273.24,381.8,275.36,382.28,278.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,285.9c3.21-10.14,12-16,19.76-22.59s20.22-17.48,20.22-17.48h0l42.2-8.62c2.73,5.59,6,17.1,6,25.23,0,7.59-1.16,16.71-14.42,26.56-8.05,6-14.39,12.84-20.44,16-6.56,3.44-15.58,10.68-27.28,6.33-5.4-2-8-7.32-6.62-12h0c-.93.09-1.86.14-2.72.14s-1.93,0-2.65,0a22.25,22.25,0,0,1-7.74-1.17C298.88,296.24,296.23,291.78,298.09,285.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,299.44c.86,0,1.79-.06,2.72-.15,4.89-10.44,30.37-30.61,31.78-31.82l.07-.07-.17-.17-1-1.47h0a40.07,40.07,0,0,0-3.54-6,40,40,0,0,0,2.38,6.94c-3.3,2.95-18.71,16-22.4,19.52C320.67,289.93,316.64,294.21,314.76,299.44Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.49,307.7c5.27-.54,18.12-6.78,22.28-13.71,4.47-7.48-3-2-3-2S350,304.89,344.49,307.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,243.31l-47.7,4.77s-23.54,17.63-31.71,27.82c0,0,8.49.23,14.35,4.38s7.33,8.67,7.33,8.67,5.45-1.85,14,2.7a23.85,23.85,0,0,1,11.13,11.94s4.19-2.63,9.55-5.76c6.91-4,15.93-9.54,22.21-18.46C388.9,269.81,387.28,250.3,383,243.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.13,265.76h0a39.56,39.56,0,0,0-3.53-6,40,40,0,0,0,2.38,6.94c-3.3,2.95-18.71,16-22.4,19.52l-.45.43a12,12,0,0,1,1.15,2.28h0c8.4-8.94,23-20.62,24-21.48l.07-.07-.17-.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.14,199.21l.24-.11c15.3-7.21,21.44-24.18,20.69-40.28A42.49,42.49,0,0,0,380,143.94a25.23,25.23,0,0,0-9.64-11.58A24.09,24.09,0,0,0,359.25,129c-3.54-.24-8.13-.18-11.46,1.19-1.45.59-1.72.46-3.28.11a11.13,11.13,0,0,0-3.64-.22,12.65,12.65,0,0,0-8.32,4.9c-2.82,3.47-4,8.94-2.18,12.87.93,2,3.16,4.79,3.05,6.64-.17,2.69-2.12,4.79-4.28,7.15s-4.54,4.07-5.58,7.49c-.89,2.94-1.05,9.17,5.53,11.56-9.58,12.66-.13,19.53,5.09,21.35a25.36,25.36,0,0,0,10.88,1.32C350.87,202.65,356.79,201.7,362.14,199.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.07,220.71c5.63-5.8,15.81-18.91,15.81-18.91l5.75-19.94c.14.06-2.93.07-3.86,0-6.22.42-8,.95-11.92,5.18-3.07,3.37-14.79,19.38-18.87,24.76L305.17,198c-2.59-3.92-2.17-8.3-3.52-11.5s-3.51-4.61-5.25-7.5-2.16-4.78-3.59-3.31.22,5.47.44,6.38,2.39,3.61-1.25,2.2-9.27-8.06-10.72-9.42-2.21.75-1.89,2.41-1.23,5.42-.67,8.18c.6,2.92,1,4.26,3.85,7.1,2.63,2.65,9.06,5.89,11.57,9.36s7.88,14.26,11.16,20.76c4.17,8.26,7.72,11,12.4,8.2S327,222.85,329.07,220.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,211.81a13.19,13.19,0,0,1,3.93,7.26s1.21-4-3-8.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.38,217c-7.65-6.29-5.13-14.49-2.34-20,5.59-11,11.4-15.38,13.82-15.34l15.22.14c7.27,1,12.9.5,14.66.91,4.47,1.06,4.57,4.75,4.74,9.51.2,5.22.75,4.66-.61,13.3,0,0-2.07,6.69-2.89,9.68s-2.33,7.63-1.1,12.46c.47,1.87,1.74,3.69,3.65,8.84a74.68,74.68,0,0,1,3.88,13.09s-10.42,9.66-32.11,6.56c-16-2.28-19.1-7.54-19.1-7.54l3-18.61C336.79,223.49,336.69,221.14,336.38,217Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,215.37s6.25,5,13.53,2.59a12.35,12.35,0,0,0,8.44-8.74s.63,8.28-8.55,10.94A12,12,0,0,1,346.32,215.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,166.49c-3.25-4-12.1-14.14-13.72-16.16a9.21,9.21,0,0,0-3.84-2.87,10,10,0,0,1-3.54-2.27c-.64-.62-2-3.24-2.55-3.93a25,25,0,0,0-5.82-5.42c-2.57-1.79-5-2.63-7.63-4.34-1.55-1-3.44-2-1.75-3.69a3.8,3.8,0,0,1,1.94-1.06c3.59-.68,7.47.45,12,1.63a53.92,53.92,0,0,1,5.7,1.78,11.48,11.48,0,0,1,3,1.53,12.85,12.85,0,0,1,2.69,3.58c2.11,3.44,6.92,5.74,9.92,8.36,3.51,3.08,7,5.66,11,9.06,3.6,3.06,8,7,10.89,10.82,2.46,3.27,1.72,5.22.73,6.68-5,7.36-16.12,15.71-20.08,19-4.22,3.49-7.18,5.66-10.95,9a96.8,96.8,0,0,0-7.5,8,1.66,1.66,0,0,1-2.05.47c-4.37-2.38-7.28-14.55-3.9-22,.86-1.92,1.76-2,1.76-2,6.89-4.84,23.76-16.14,23.76-16.14",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,166.49a17.22,17.22,0,0,0,7.87,5.62s-4.18,1-9.78-4.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,158.62c.06,12,3.91,15,5.84,15.92s5.71.43,9.38-.11l-.13,7.2s-4.29,4.35-4,7.66,6.56,3.78,11.36.64a36.41,36.41,0,0,0,7.11-6.2,2.58,2.58,0,0,0,.64-1.65l.29-17s2,2.16,5.56-.21a6.53,6.53,0,0,0,1.84-9.46c-1.51-1.84-5.43-2-7.36.75-1.09,2-1,3.49-2.44,3.25s-1.56-1.86-1.66-3-.05-1.53-.14-3c-3.55-.76-7.22-5.7-7.63-9.31a17,17,0,0,1-7.72,1.74c-4-.27-6-1.07-8-3.93a8.17,8.17,0,0,0-1.11,2.13,26.8,26.8,0,0,0-1.23,4.71A61.35,61.35,0,0,0,338.72,158.62Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,174.43c3.87-.44,11.85-2.58,13.14-5.7a8.07,8.07,0,0,1-2.85,4c-2.41,2-10.33,4.14-10.33,4.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.07,156.15a1.67,1.67,0,0,0,1.54,1.82,1.73,1.73,0,1,0-1.54-1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85,155.43a1.54,1.54,0,0,0,1.4,1.66,1.45,1.45,0,0,0,1.62-1.46,1.51,1.51,0,1,0-3-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.35 152.85 347.8 164.16 342.52 162.4 348.35 152.85",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,151.81l-3-2.84a2.15,2.15,0,0,0,.09,3A2,2,0,0,0,358.3,151.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.9,164.84l-5.32,1.73a2.94,2.94,0,0,0,3.63,1.83A2.72,2.72,0,0,0,353.9,164.84Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21,168.4a2.68,2.68,0,0,0,1.83-2.26,2.5,2.5,0,0,0-.91-.18,2.57,2.57,0,0,0-2.57,2.46A2.81,2.81,0,0,0,352.21,168.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.75,148.05l-3.31,2.51a2,2,0,0,0,2.86.47A2.19,2.19,0,0,0,342.75,148.05Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bean-bag--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.68,176.33c-14.91,8.61-36.49,29-36.49,65.69s17.36,64,50.6,76.24c17.78,6.53,46.28,6.87,64.6.33,18.67-9.55,31.25-19.38,38.1-37.21,7-20.7-5.57-42.38-22.73-54.76s-15.12-26.5-27.26-41.16c-6.52-7.88-16.13-14.62-27.85-15.92C118.86,168.11,104,169.78,92.68,176.33Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,237.73c-11-6.12-13.2-12.81-22.8-37.74s-27.1-23.05-27.1-23.05-25.71.87-31.85,19.19c-4.25,12.65-4.16,37.59-.16,51,2.4,8.06,5.68,11.87,5.68,11.87-12.63-2.49-22.7,6-22.7,6s10.66-5.06,28.16,2c10.37,4.15,22.15,9.87,32.76,14.22,9,3.7,13.91,6.42,20.95,12.12a32.5,32.5,0,0,1,11.81,20.78,12.61,12.61,0,0,0,1,4.1c11.13-5.74,20.07-11.62,26.88-19.31.21-2.48.06-5,.13-7.53.24-9.17.36-18.37-.13-27.54C197.78,242.81,187.38,243.85,176.32,237.73Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,237.73c-11-6.12-13.2-12.81-22.8-37.74s-27.1-23.05-27.1-23.05-24.49.87-30.64,19.19c-4.24,12.65-5.37,37.59-1.37,51,2.4,8.06,5.68,11.87,5.68,11.87-12.63-2.49-22.7,6-22.7,6s8.19-2,26.5,2.44c10.09,2.47,20.35,7.12,30.66,12.16,10.61,5.19,17.67,8,24.71,13.7,6.33,5.13,12,11.91,13,20a18.32,18.32,0,0,1-.27,4.85c11.13-5.74,20.07-11.62,26.88-19.31.21-2.48-.17-5.06.13-7.53,1.32-11,1.56-14.23,2.59-24.85C203.37,248.53,187.38,243.85,176.32,237.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,320.87c-21.28,2.49-43.54-2.75-61-14.63C75.65,288,64.07,259.19,69.8,225c5.06-30.19,20.15-46.82,35.31-53.69a53,53,0,0,0-9.77,3.6c-12.27,9-23.18,24.87-27.36,49.79-5.85,34.93,6,64.43,33.38,83A92,92,0,0,0,147,323.12,102.09,102.09,0,0,0,163.41,320.87Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.84,292s-3,14-2.39,19.17c.66,5.41-.33,7.41,1.61,13.08.42,1.24,1.53,3.67,1.88,4.67a1.54,1.54,0,0,1-1,2.14c-2.24.89-6.88-2.8-9.55-7.23a143.51,143.51,0,0,1-7.55-16,7.37,7.37,0,0,1,.07-3.88,12.52,12.52,0,0,1,.73-2.13c.36-2.47,0-7,.06-10.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,313.55a5.7,5.7,0,0,0-.32,1.87c.14,1.08,3.17,4.17,4.34,5.29A8.77,8.77,0,0,1,175,326.5c.46,3.45,2.55,6.47,5.26,8.91a23.91,23.91,0,0,0,13,5.6c6,.74,7.45-2.44,7.45-2.44s1.27-3,0-4S168.11,313.55,168.11,313.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,301.85c-.17,0-.48,0-.83.64-.13.23-.72,2.95-1.34,4.44s-2.42,4.41-2.32,6.62c2,4,6.48,6.18,7.76,10S178,332,185,335.77s13.26,3.17,15.28,1.5,1.39-4-2.54-8.08c-4.18-4.27-8.27-14.41-8.27-14.42a36.89,36.89,0,0,1-1.37-4.37,29.4,29.4,0,0,1-.36-4.51,3.35,3.35,0,0,0-.64-2,3.45,3.45,0,0,0-1.87-.86,15.51,15.51,0,0,0-3.31-.51,5,5,0,0,0-3.14,1c-.64.5-1.11,1.2-1.79,1.63a2.9,2.9,0,0,1-3.07,0,2.49,2.49,0,0,1-1.29-2.6A5.25,5.25,0,0,1,172.6,301.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,332.52a9.84,9.84,0,0,1,8-6.31c6.45-1.11,9.26,1.78,10.58,3.54,1.57,2.09,3.52,6,1.07,7.71-2.65,1.79-6.05,2-11.75.27S180.72,332.52,180.72,332.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48,312.89a.69.69,0,0,0,.59-.11c.91-.68,6-2.71,9.56-.4.34-.39.15-1-.5-1.69-4-1.65-8.8.24-9.9,1.07a.63.63,0,0,0-.1.9A.79.79,0,0,0,178.48,312.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,316a2,2,0,0,0-.68-1.71,12.24,12.24,0,0,0-9.4,1.27.62.62,0,0,0-.1.9.74.74,0,0,0,.35.23.69.69,0,0,0,.59-.11C181.59,315.94,186.41,314,190,316Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.11,324.27a3.74,3.74,0,0,0-1.23-2.19c-4-1.53-8.66.33-9.74,1.14a.62.62,0,0,0-.1.9.74.74,0,0,0,.35.23.69.69,0,0,0,.59-.11C184.94,323.52,190.54,321.3,194.11,324.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,320.53a.69.69,0,0,0,.59-.11c.9-.67,5.87-2.66,9.44-.47a2.31,2.31,0,0,0-.88-1.82,12.25,12.25,0,0,0-9.4,1.27.63.63,0,0,0-.1.9A.79.79,0,0,0,181.75,320.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,227.8c7.38,4.71,31.21,14.37,41.77,22.95,3.06,2.49,5.65,6.3,4.44,13.9-2.26,14.21-7,32.47-7,32.47l-16.09-6.23-3.59-15.63-22.79-14.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,298.13c-9.49-6.94-40.25-49.75-40.24-49.76,6.38-2.74,9.78-11.46,9.78-11.46a21.24,21.24,0,0,1-3.94,11.46c4,2.54,13,7.45,22.47,14a17.25,17.25,0,0,1,6.38,9.13C187.17,281.1,190.34,296.15,190.25,298.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87,303.91s5.37,16.63,9.5,22.77,6.22,9.1,11.29,13.46c1.11.95,3.55,2.65,4.46,3.42a1.72,1.72,0,0,1,.21,2.65c-1.65,2.13-9.75,3.78-14.83,1s-10.34-9.43-13.48-11.78c-1.18-.88-2.3-1.8-3.39-2.79s-1-2-1.22-3.22c-.12-.58-.28-2.2-.28-2.2-1-2.77-3.41-7-4.73-9.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.44,340.37a6.26,6.26,0,0,0,.52,2.05c.62,1,5.12,2.84,6.82,3.46a9.7,9.7,0,0,1,5.48,4.64c2,3.32,5.53,5.47,9.39,6.74a26.64,26.64,0,0,0,15.84-.15c6.42-1.92,6.51-5.84,6.51-5.84s-.07-3.67-1.76-4.06S187.44,340.37,187.44,340.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,326.4c-.17.1-.49.24-.57,1,0,.3.6,3.34.64,5.14s-.49,5.59.6,7.81c3.87,3.12,9.41,3.4,12.45,6.75s6,7.64,14.77,8.37,15-2.73,16.28-5.35-.39-4.76-6.23-7.1c-6.19-2.49-14.93-11-14.94-11a37.45,37.45,0,0,1-3.37-3.85,33.21,33.21,0,0,1-2.4-4.44,3.78,3.78,0,0,0-1.53-1.72,3.84,3.84,0,0,0-2.3,0,16.45,16.45,0,0,0-3.61,1,5.63,5.63,0,0,0-2.79,2.39,26,26,0,0,1-1.08,2.47,3.25,3.25,0,0,1-3.15,1.38,2.81,2.81,0,0,1-2.49-2.08S186.77,326.4,186.77,326.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.87,354.07a11,11,0,0,1,5.3-10c6.1-4,10.27-2.35,12.41-1.15,2.55,1.43,6.32,4.59,4.56,7.39-1.89,3-5.28,4.75-11.88,5.58S208.87,354.07,208.87,354.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,335a.75.75,0,0,0,.56-.37c.62-1.11,4.89-5.47,9.58-4.72.17-.55-.27-1.05-1.27-1.5-4.82.11-8.88,4.21-9.63,5.55a.7.7,0,0,0,.3,1A.83.83,0,0,0,197.74,335Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.87,333.06a2.26,2.26,0,0,0-1.47-1.44c-4.55.42-8.31,4.25-9,5.53a.69.69,0,0,0,.31,1,.73.73,0,0,0,.46.08.76.76,0,0,0,.55-.38C202.29,336.74,206.35,332.61,210.87,333.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.84,339.62a4.16,4.16,0,0,0-2.25-1.68c-4.73.22-8.7,4.23-9.43,5.54a.7.7,0,0,0,.3,1,.83.83,0,0,0,.46.07.72.72,0,0,0,.55-.37C209.13,343,213.85,338.19,218.84,339.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.53,341.36a.77.77,0,0,0,.55-.38c.61-1.09,4.8-5.36,9.43-4.73a2.59,2.59,0,0,0-1.71-1.46c-4.56.42-8.32,4.25-9,5.53a.69.69,0,0,0,.31,1A.74.74,0,0,0,204.53,341.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.93,224h0l-49.05,8.84c0,11.39,3,19.41,6.24,23.38,3.5,4.24,9.87,9.17,22.44,13.9,16.74,6.29,20.06,7.66,26,10.12,4.23,1.75,6.85,3,10.21,11.2,2.42,5.91,17.6,30,17.6,30a32.44,32.44,0,0,0,13.94-7.77c-13.86-39.9-18-46.09-23.86-50.63-5-3.89-24.44-14.63-24.44-14.63S157.14,235.84,150.93,224Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,206.41c-4.94-3.29-22.88-17.36-22.88-17.36l-4.48-25.73c5.54.8,7.26,2.47,17.27,12,6,5.75,17.53,16.17,17.53,16.17,3-2.86,13.42-13.66,15.5-16.52a35.47,35.47,0,0,0,4.48-8.83c.46-1.41.89-2.84,1.49-4.22a23.88,23.88,0,0,1,1.89-3.34c.68-1,1.28-2.25,1.94-3.23a1.33,1.33,0,0,1,.42-.46,1.07,1.07,0,0,1,1.25.31,5.42,5.42,0,0,1,.7,3.17,10.61,10.61,0,0,1-.57,2.35,5.92,5.92,0,0,0-.35,2.38,3.77,3.77,0,0,0,2.66-.9,31.79,31.79,0,0,0,6.67-6.88c1.28-1.66,2.35-3.45,3.71-5.06a2.67,2.67,0,0,1,.87-.77,1,1,0,0,1,1.09.12,1.47,1.47,0,0,1,.28,1,25.35,25.35,0,0,1-.19,3.26c1,.53,1.27,1.85,1.41,3,.31,2.63.61,5.38-.33,7.87a14.74,14.74,0,0,1-4,5.3,57.47,57.47,0,0,1-5,4.17c-1.69,1.26-3.55,2.25-4.92,3.88-4.66,5.52-13.54,19-20,26.09S185.87,210.78,179.77,206.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,163.09c5.59,0,6.67,1.3,11.1,4.86s19.5,18.59,19.5,18.59a25.44,25.44,0,0,1-10.49,15l-23.69-17.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41,196.13c2.43-16.61,4.5-30-4.59-33l-10.76-1.42-9.11.22c-10.73.92-18.33.43-21.46,6.47,0,0-4.95,1.95-7.73,24a212.68,212.68,0,0,0-.89,47c11.67,6.71,45.38,2.71,53.58-9.64C154.16,216.65,154.42,209.76,156.41,196.13Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41,196.13c2.43-16.61,4.5-30-4.59-33l-10.76-1.42-9.11.22c-10.73.92-18.33.43-21.46,6.47,0,0-4.95,1.95-7.73,24a212.68,212.68,0,0,0-.89,47c11.67,6.71,45.38,2.71,53.58-9.64C154.16,216.65,154.42,209.76,156.41,196.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62,131a15.75,15.75,0,0,0-31.19-4.11l-6.65-5.74a5.62,5.62,0,0,0-4.74,1.26c-2.14,1.88-1.53,8.31.45,14.72,0,0,1.51,11.5,2.33,13.44a5.16,5.16,0,0,0,2.78,2.62l.39-6.88,28.68.62L156,144.61A15.75,15.75,0,0,0,166.62,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,138.06c-1,.48-1.59-1.51-3.14-2.64-1.32-1-4.51-2.16-6.7.56-2.73,3.39,0,8.2,2.75,9.74,3.93,2.18,5.95-.57,5.95-.57l-.68,17.94c5.32,8.23,22,9.58,16.79.24l.33-4.87a31.93,31.93,0,0,0,6.67.87c3.7-.28,6.23-3,7.65-6.85,2.28-6.21,3.36-11.29,2.83-23.9-.58-13.83-16.5-15.22-25.52-10.49S130.34,138.06,130.34,138.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.45,116.16a5.9,5.9,0,0,0-3.8-.81,4.69,4.69,0,0,0-2.35-4.94,5.41,5.41,0,0,0-6,.24c.52-1.35-.61-2.88-2-3.32a7.5,7.5,0,0,0-4.26.3c-2.08.57-4.12,1.24-6.22,1.73-3.69.86-7.56,1.19-11,2.82a6.76,6.76,0,0,0-2.19,1.53,5.71,5.71,0,0,0-1.25,3.47,10.2,10.2,0,0,0,.06,1.24,2.9,2.9,0,0,0-.78-.74,3,3,0,0,0-4.28,1l5.14,3.29c-.24,1.08-.48,2.15-.69,3.23-.56,2.85-1.43,6.15-1,9.07a2.25,2.25,0,0,0,.27,1,17,17,0,0,1,2.55,3c.37.55.79,1.42,1.45,1.68a1.62,1.62,0,0,0,1.94-.68,2.82,2.82,0,0,0,.18-1.26c0-1.79,0-3.58,0-5.37a3,3,0,0,1,.22-1.4,4,4,0,0,1,1.43-1.26,6.19,6.19,0,0,0,2.51-4.06,6.5,6.5,0,0,1,.29-1.51c.14-.36.49-.92.92-.88.83.07,5.26,1.48,6.38,1.74,5.83,1.36,12.16,2.11,17.64-.3,2.14-.94,5.78-3,6.37-5.44A3.36,3.36,0,0,0,167.45,116.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,158.46s-8-2.29-10.76-4a9.33,9.33,0,0,1-3.63-4.21,12.83,12.83,0,0,0,1.88,4.78c1.87,2.83,12.34,5.63,12.34,5.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.19,138.16a1.54,1.54,0,1,1-1.41-1.72A1.56,1.56,0,0,1,147.19,138.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.75,132.18,141,133.59a2.1,2.1,0,0,1,1.21-2.65A2,2,0,0,1,144.75,132.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,148.42l5.1,2.39a2.76,2.76,0,0,1-3.71,1.46A3,3,0,0,1,144.49,148.42Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.47,152.49a2.76,2.76,0,0,0-2.86-2.64,2.11,2.11,0,0,0-.35.05,2.91,2.91,0,0,0,1.62,2.37A2.69,2.69,0,0,0,147.47,152.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,135l-3.29-2.13a1.89,1.89,0,0,1,2.66-.57A2,2,0,0,1,161.64,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.48,139.05a1.54,1.54,0,1,1-1.4-1.72A1.57,1.57,0,0,1,159.48,139.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.77 137.37 151.15 147.29 157.11 146.48 151.77 137.37",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,223c-.08-.35,1.17-.75,1.43-.88,1.64-.8,3.38-1.69,4.26-3.29.31-.55.46-1.33,0-1.75s-1.14-.22-1.71,0a35.71,35.71,0,0,1-5.84,1.4,44.54,44.54,0,0,0-5.56,1.34c-1.87.54-3.52,1.61-5.45,1.78a42.69,42.69,0,0,1-6.29-.24c-9.94-.75-24.62-2.94-25.59-3.13l-13-31.79s-2.65-17.7-9.57-23c-5.79,1-13.54,7.49-11.92,19.75,1.17,8.81,14.58,38.72,16.6,43,3.09,6.62,2.94,8.32,15.83,9,5.84.31,18.14-.1,26.34.25l6.11.25c2.34.08,5.17.28,7.51.5",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,232.45l16.69-4.74a2.1,2.1,0,0,0,1.35-1.44l5.81-26.73c.14-.62-.25-1-.86-.81l-16.68,4.73a2.13,2.13,0,0,0-1.36,1.44l-5.81,26.73C183,232.26,183.38,232.62,184,232.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,209c3.07-.7,4.95,1.36,4.21,4.62s-3.81,6.41-6.82,7.06-4.91-1.41-4.21-4.61A10,10,0,0,1,197.25,209Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,218.5a.63.63,0,0,1-.16.25.6.6,0,0,1-.24.14l-1.41.32a.18.18,0,0,1-.18-.05.22.22,0,0,1,0-.21l.41-1.2a.63.63,0,0,1,.17-.24.53.53,0,0,1,.24-.15l1.41-.31a.16.16,0,0,1,.18,0,.23.23,0,0,1,0,.2Zm1.82-7.89a3.12,3.12,0,0,1,1.11-.08,1.61,1.61,0,0,1,.79.29,1.07,1.07,0,0,1,.37.63,1.75,1.75,0,0,1-.1.93,3.56,3.56,0,0,1-.39.78,4.78,4.78,0,0,1-.54.65,8.25,8.25,0,0,1-.61.58l-.62.51c-.2.17-.38.34-.55.51a2.48,2.48,0,0,0-.42.54,1.14,1.14,0,0,1-.18.25.44.44,0,0,1-.23.14l-1.36.31a.18.18,0,0,1-.18-.05.22.22,0,0,1,0-.21,2.71,2.71,0,0,1,.39-.73,5,5,0,0,1,.57-.65c.2-.2.42-.4.64-.58l.63-.52a6,6,0,0,0,.51-.48,1.43,1.43,0,0,0,.3-.47c.08-.23.06-.39-.06-.49a.89.89,0,0,0-.69,0,2,2,0,0,0-.78.32,2.46,2.46,0,0,0-.43.42l-.3.39a.55.55,0,0,1-.34.23l-1.36.3a.14.14,0,0,1-.15,0,.19.19,0,0,1,0-.18A4.24,4.24,0,0,1,194,213a6.78,6.78,0,0,1,.9-1,7,7,0,0,1,1.18-.85A5,5,0,0,1,197.43,210.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.89,163.32c-6.55.73-9.63,2.67-11.83,6.9-2.92,5.63-1.57,12.87.4,19.25a171.5,171.5,0,0,0,9,22.55s10.21.56,19.48-8l-7.25-20.87S124,169.2,117.89,163.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.12,236.17c4.43.4,8.08.51,12.27-1.09a13.79,13.79,0,0,0,5.6-3.72,7.61,7.61,0,0,0,.95-1.37,7.37,7.37,0,0,0,.42-1.36c.15-.4.27-.85.44-1.23a11.06,11.06,0,0,1,.75-1.17,5.62,5.62,0,0,0,.86-2.53,4.37,4.37,0,0,1,1-3.69c.47-.94.23-2.4-1.08-2.23a6.3,6.3,0,0,0-2.54,1.22,35.88,35.88,0,0,1-5.1,2.85c-1.66.75-3.53,1.65-5.39,1.57-.3,0-1.19,0-1.28-.41",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.17,373.72a2.82,2.82,0,0,1,1.66-2.32,8.88,8.88,0,0,1,8,0,2.82,2.82,0,0,1,1.66,2.31l-1.66,41.73h0a2,2,0,0,1-1.17,1.6,6.27,6.27,0,0,1-5.66,0,2,2,0,0,1-1.17-1.6h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.83,371.4a8.88,8.88,0,0,0-8,0,2.82,2.82,0,0,0-1.66,2.32l.55,13.84a61.41,61.41,0,0,0,9.9,8.1l.87-22A2.82,2.82,0,0,0,173.83,371.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,373.72a2.82,2.82,0,0,0-1.66-2.32,8.88,8.88,0,0,0-8,0,2.82,2.82,0,0,0-1.66,2.31l1.66,41.73h0a2,2,0,0,0,1.17,1.6,6.27,6.27,0,0,0,5.66,0,2,2,0,0,0,1.17-1.6h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.36,371.4a8.88,8.88,0,0,0-8,0,2.82,2.82,0,0,0-1.66,2.31l.89,22.39a63.17,63.17,0,0,0,9.85-7.7l.58-14.68A2.82,2.82,0,0,0,338.36,371.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,405a2.8,2.8,0,0,0-1.66-2.31,8.81,8.81,0,0,0-8,0,2.8,2.8,0,0,0-1.66,2.31l1.66,41.73h0a2,2,0,0,0,1.17,1.59,6.21,6.21,0,0,0,5.66,0,2,2,0,0,0,1.17-1.59h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.72,418.16l.52-13.13a2.8,2.8,0,0,0-1.66-2.31,8.81,8.81,0,0,0-8,0,2.8,2.8,0,0,0-1.66,2.31l.52,13.13C250.77,418.28,254.39,418.28,257.72,418.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,344.17H354c0-15-9.81-30-29.63-41.43-39.63-22.88-103.88-22.88-143.5,0-19.82,11.44-29.65,26.43-29.63,41.43h-.09v8.05h0c.23,14.8,10.16,29.55,29.72,40.84,39.63,22.88,103.88,22.88,143.5,0,19.56-11.29,29.49-26,29.72-40.84h0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,344.17H354c0-15-9.81-30-29.63-41.43-39.63-22.88-103.88-22.88-143.5,0-19.82,11.44-29.65,26.43-29.63,41.43h-.09v8.05h0c.23,14.8,10.16,29.55,29.72,40.84,39.63,22.88,103.88,22.88,143.5,0,19.56-11.29,29.49-26,29.72-40.84h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,302.74c-39.63,22.88-39.63,60,0,82.86s103.88,22.87,143.5,0,39.63-60,0-82.86S220.45,279.86,180.83,302.74Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,302.74c-39.63,22.88-39.63,60,0,82.86s103.88,22.87,143.5,0,39.63-60,0-82.86S220.45,279.86,180.83,302.74Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Game--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-14",
    points: "170.31 345.94 252.57 298.45 334.83 345.94 252.57 393.44 170.31 345.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "170.31 344.04 252.57 296.54 334.83 344.04 252.57 391.53 170.31 344.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 389.4 174 344.04 252.57 298.67 331.15 344.04 252.57 389.4",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.22 350.52 196.45 344.04 207.67 350.52 196.45 357 185.22 350.52",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.22 337.56 196.45 331.07 207.67 337.56 196.45 344.04 185.22 337.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.45 331.07 207.67 324.59 218.9 331.07 207.67 337.56 196.45 331.07",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.67 324.59 218.9 318.11 230.12 324.6 218.9 331.07 207.67 324.59",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.9 318.11 230.12 311.63 241.35 318.11 230.12 324.59 218.9 318.11",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.12 311.63 241.35 305.15 252.57 311.63 241.35 318.11 230.12 311.63",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 376.44 263.8 369.96 275.02 376.44 263.8 382.92 252.57 376.44",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.8 369.96 275.02 363.48 286.25 369.96 275.02 376.44 263.8 369.96",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.02 363.48 286.25 357 297.47 363.48 286.25 369.96 275.02 363.48",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.25 357 297.47 350.52 308.7 357 297.47 363.48 286.25 357",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.47 350.52 308.7 344.04 319.92 350.52 308.7 357 297.47 350.52",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.45 357 207.67 350.52 218.9 357 207.67 363.48 196.45 357",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.9 369.96 230.12 363.48 241.35 369.96 230.12 376.44 218.9 369.96",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.67 363.48 218.9 357 230.12 363.48 218.9 369.96 207.67 363.48",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.12 376.44 241.35 369.96 252.57 376.44 241.35 382.92 230.12 376.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 311.63 263.8 305.15 275.02 311.63 263.8 318.11 252.57 311.63",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.8 318.12 275.02 311.63 286.25 318.12 275.02 324.6 263.8 318.12",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.02 324.6 286.25 318.12 297.47 324.6 286.25 331.08 275.02 324.6",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.25 331.08 297.47 324.6 308.7 331.08 297.47 337.56 286.25 331.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.47 337.56 308.7 331.08 319.92 337.56 308.7 344.04 297.47 337.56",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,350.78l.92-.53L309.62,344l10.76-6.22-.92-.53-10.76,6.22-10.31-5.95,10.77-6.22-.92-.53L297.47,337l-10.3-5.95,10.76-6.22-.92-.53-10.76,6.22-10.31-5.95,10.77-6.22-.92-.53L275,324.06l-10.3-5.94,10.76-6.22-.92-.53-10.76,6.21-10.31-5.95,10.76-6.21-.92-.53-10.76,6.21-10.76-6.21-.93.53,10.77,6.21-10.31,5.95-10.76-6.21-.92.53,10.76,6.21-10.3,5.95-10.77-6.21-.92.53,10.77,6.21-10.3,6-10.77-6.21-.92.53L218,331.08,207.67,337l-10.76-6.21-.93.53,10.77,6.22-10.31,5.95-10.76-6.22-.92.53L195.52,344l-10.76,6.21.92.53,10.76-6.21,10.31,5.95L196,356.73l.92.54,10.76-6.22L218,357l-10.77,6.22.92.53,10.77-6.22,10.3,6-10.76,6.22.92.53L230.12,364l10.3,5.95-10.76,6.22.92.53,10.77-6.22,10.3,5.95-10.76,6.22.92.53L252.57,377l10.77,6.22.92-.53-10.77-6.22,10.31-5.95,10.76,6.22.92-.53L264.72,370,275,364l10.77,6.22.92-.53-10.77-6.22,10.31-6L297,363.75l.92-.54L287.17,357l10.3-5.95,10.77,6.22.92-.54-10.77-6.21,10.31-5.95Zm-66.89,25.13L197.37,344l55.2-31.88L307.78,344Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 311.63 196.45 344.04 252.57 376.44 308.7 344.04 252.57 311.63",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Deck--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.93,346.13a.57.57,0,0,0-.33-.46l-23.09-13.33a1.78,1.78,0,0,0-1.59,0l-14.86,8.58a.57.57,0,0,0-.33.46v7.23a.56.56,0,0,0,.33.46l23.09,13.33a1.74,1.74,0,0,0,1.6,0l14.85-8.58a.56.56,0,0,0,.33-.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,355.37v7.22a1.61,1.61,0,0,1-.81-.18l-23.1-13.34a.57.57,0,0,1-.33-.46v-7.22a.57.57,0,0,0,.33.46l23.1,13.33A1.73,1.73,0,0,0,253,355.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,355.18l-23.09-13.34c-.44-.25-.44-.66,0-.92l14.86-8.58a1.78,1.78,0,0,1,1.59,0l23.09,13.33c.44.26.44.67,0,.92l-14.85,8.59A1.8,1.8,0,0,1,252.15,355.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.93,346.13v7.23a.56.56,0,0,1-.33.46l-14.85,8.59a1.66,1.66,0,0,1-.78.18v-7.22a1.64,1.64,0,0,0,.78-.19l14.85-8.59A.54.54,0,0,0,268.93,346.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.73 342.96 233.86 345.92 228.73 342.66 228.73 342.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.73 346.75 233.86 349.71 228.73 346.45 228.73 346.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.73 344.59 237.75 349.93 228.73 344.29 228.73 344.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.09,352.4l7.26,4.19a1.25,1.25,0,0,0,1.24,0l6.84-4-6.9,3.58a1.19,1.19,0,0,1-1.13,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.15,356.31l4.2,2.43a1.22,1.22,0,0,0,1.24,0l6.84-4-6.9,3.59a1.25,1.25,0,0,1-1.13,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.09,356.68l7.26,4.2a1.22,1.22,0,0,0,1.24,0l6.84-4-6.9,3.59a1.25,1.25,0,0,1-1.13,0Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.43,354.75l-6.9,3.59a1.21,1.21,0,0,1-.56.13v.43a1.26,1.26,0,0,0,.62-.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253,356.33v.43a1.26,1.26,0,0,0,.62-.17l6.84-4-6.9,3.58A1.11,1.11,0,0,1,253,356.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.59,360.87l3.07-1.79-3.13,1.4a1.22,1.22,0,0,1-.56.14V361A1.16,1.16,0,0,0,253.59,360.87Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "268.93 349.29 263.5 352.4 268.93 349.63 268.93 349.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.93 351.63 263.5 354.75 268.93 351.98 268.93 351.63"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,345.67l-23.09-13.33a1.78,1.78,0,0,0-1.59,0l-14.86,8.58a.64.64,0,0,0-.25.24.71.71,0,0,0,.25.23l23.09,13.34a1.8,1.8,0,0,0,1.6,0l14.85-8.59a.71.71,0,0,0,.25-.23A.64.64,0,0,0,268.6,345.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,354.37,229.06,341c-.44-.26-.44-.67,0-.92l14.86-8.58a1.72,1.72,0,0,1,1.59,0l23.09,13.33c.44.25.44.66,0,.92l-14.85,8.58A1.8,1.8,0,0,1,252.15,354.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,340.15a10.72,10.72,0,0,1,9.71,0c2.69,1.55,2.69,4.06,0,5.61a10.78,10.78,0,0,1-9.71,0C241.29,344.21,241.29,341.7,244,340.15Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.47,340.78a5.72,5.72,0,0,1,1.16-.5,6.13,6.13,0,0,1,1.24-.23,4.54,4.54,0,0,1,1.17,0,2.83,2.83,0,0,1,1,.34,1.49,1.49,0,0,1,.49.41,1.09,1.09,0,0,1,.17.44,1.3,1.3,0,0,1,0,.44c0,.15-.06.29-.08.43a1.82,1.82,0,0,0,0,.4.59.59,0,0,0,.18.35.29.29,0,0,1,.09.16c0,.05,0,.1-.09.14l-1.17.67a.59.59,0,0,1-.52,0,1.05,1.05,0,0,1-.43-.4,1.07,1.07,0,0,1-.14-.45,1.46,1.46,0,0,1,0-.46c0-.15.06-.29.09-.43a1.15,1.15,0,0,0,0-.37.47.47,0,0,0-.23-.28,1.12,1.12,0,0,0-.64-.13,1.94,1.94,0,0,0-.81.29c-.29.16-.45.31-.49.43a.39.39,0,0,0,0,.32c0,.09.09.17.13.25s0,.14-.11.21l-1.17.68a.47.47,0,0,1-.42,0,1.49,1.49,0,0,1-.51-.52,1.11,1.11,0,0,1-.16-.69,1.58,1.58,0,0,1,.31-.78A3.05,3.05,0,0,1,245.47,340.78Zm7.37,3.29a.16.16,0,0,1,0,.3l-1.2.7a.59.59,0,0,1-.52,0l-1-.56a.16.16,0,0,1,0-.3l1.21-.69a.59.59,0,0,1,.52,0Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cards--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.5,330.24a1.84,1.84,0,0,1-.53-.08l-26.83-8a.91.91,0,0,1-.67-.56.55.55,0,0,1,.14-.55l8.91-10a1.48,1.48,0,0,1,1.06-.38,1.79,1.79,0,0,1,.53.07l5,1.5-7.2-4.17a.62.62,0,0,1,0-1.16L262.65,299a1.7,1.7,0,0,1,.83-.21,1.67,1.67,0,0,1,.83.21l10.5,6.06-2.16-3.4a.57.57,0,0,1,0-.52,1,1,0,0,1,.79-.53l18.24-3.86a1.67,1.67,0,0,1,.39,0,1.33,1.33,0,0,1,1.14.48l10.39,16.35a.57.57,0,0,1,.05.52,1.07,1.07,0,0,1-.79.54l-18.23,3.86a1.81,1.81,0,0,1-.4,0h0A1.35,1.35,0,0,1,283,318l-1.87-2.94-5.3,3.06,2.06.61a.92.92,0,0,1,.67.57.53.53,0,0,1-.14.54l-8.9,10A1.44,1.44,0,0,1,268.5,330.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,319.36,249,307c-.41-.23-.41-.61,0-.85l13.74-7.93a1.65,1.65,0,0,1,1.47,0l21.34,12.32a.45.45,0,0,1,0,.86l-13.73,7.93A1.62,1.62,0,0,1,270.36,319.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.57 311.98 275.41 317.29 275.93 316.99 257.09 311.7 257.57 311.98",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.23 313.93 280.72 314.23 275.05 304.5 275.36 304.68 281.23 313.93",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,306.22a9.85,9.85,0,0,1,9,0c2.48,1.43,2.48,3.75,0,5.18a9.91,9.91,0,0,1-9,0C260.32,310,260.32,307.65,262.8,306.22Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,306.8a4.87,4.87,0,0,1,1.07-.46,5.33,5.33,0,0,1,1.14-.22,4.37,4.37,0,0,1,1.09,0,2.58,2.58,0,0,1,.91.31,1.18,1.18,0,0,1,.45.38,1,1,0,0,1,.17.41,1.13,1.13,0,0,1,0,.41c0,.13-.05.26-.07.39a1.16,1.16,0,0,0,0,.37.47.47,0,0,0,.16.32.37.37,0,0,1,.08.15c0,.05,0,.09-.08.13l-1.08.62a.48.48,0,0,1-.24.06.43.43,0,0,1-.24-.06.91.91,0,0,1-.4-.37.9.9,0,0,1-.13-.41,1.2,1.2,0,0,1,0-.42c0-.15.06-.28.08-.4a1,1,0,0,0,0-.34.36.36,0,0,0-.21-.26,1,1,0,0,0-.6-.12,1.77,1.77,0,0,0-.75.26,1,1,0,0,0-.45.4.41.41,0,0,0,0,.29,1.36,1.36,0,0,0,.13.24c0,.06,0,.13-.11.19l-1.08.63a.53.53,0,0,1-.19.05.46.46,0,0,1-.2-.05,1.35,1.35,0,0,1-.47-.48,1,1,0,0,1-.15-.64,1.54,1.54,0,0,1,.29-.72A2.71,2.71,0,0,1,264.18,306.8Zm6.82,3a.15.15,0,0,1,0,.28l-1.12.64a.43.43,0,0,1-.24.06.48.48,0,0,1-.24-.06l-.89-.51a.17.17,0,0,1-.1-.14c0-.06,0-.1.1-.14l1.11-.64a.48.48,0,0,1,.24-.06.43.43,0,0,1,.24.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,329.07l-26.83-8c-.51-.15-.71-.51-.44-.81l8.91-10a1.44,1.44,0,0,1,1.4-.26l26.82,8c.51.15.71.51.45.81l-8.9,10A1.52,1.52,0,0,1,268,329.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,317.87c1.61-1.8,5.43-2.5,8.55-1.57s4.33,3.14,2.73,4.93-5.44,2.51-8.55,1.58S252.29,319.67,253.9,317.87Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.52,318.18a3.44,3.44,0,0,1,.78-.62,3.93,3.93,0,0,1,1-.41,4.25,4.25,0,0,1,1.06-.16,3.56,3.56,0,0,1,1,.14,2.06,2.06,0,0,1,.63.29,1.64,1.64,0,0,1,.38.36,1.2,1.2,0,0,1,.2.39c.05.13.1.26.14.39a2.31,2.31,0,0,0,.18.35,1,1,0,0,0,.33.28.49.49,0,0,1,.15.12c0,.05,0,.09,0,.14l-.7.79a.41.41,0,0,1-.2.09.57.57,0,0,1-.26,0,1.68,1.68,0,0,1-.57-.28,1.33,1.33,0,0,1-.34-.38,1.69,1.69,0,0,1-.19-.41c0-.14-.09-.27-.13-.39a1.74,1.74,0,0,0-.18-.33.76.76,0,0,0-.34-.21,1.13,1.13,0,0,0-.63,0,1.09,1.09,0,0,0-.57.38c-.18.19-.25.34-.22.46a.53.53,0,0,0,.16.28l.24.19q.12.09,0,.21l-.7.79a.35.35,0,0,1-.15.08.42.42,0,0,1-.22,0,2.14,2.14,0,0,1-.7-.37,1.66,1.66,0,0,1-.48-.58,1.31,1.31,0,0,1-.09-.74A1.68,1.68,0,0,1,255.52,318.18Zm8.1,1.71a.24.24,0,0,1,.16.11.12.12,0,0,1,0,.15L263,321a.34.34,0,0,1-.2.1.58.58,0,0,1-.26,0l-1.12-.33a.23.23,0,0,1-.16-.12.1.1,0,0,1,0-.14l.72-.81a.34.34,0,0,1,.2-.1.69.69,0,0,1,.25,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,317l-10.39-16.36c-.2-.31.08-.66.62-.77L291.66,296a1.35,1.35,0,0,1,1.34.35l10.39,16.36c.2.31-.08.66-.62.78l-18.23,3.86A1.33,1.33,0,0,1,283.2,317Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,303.26c3.29-.69,6.94.28,8.15,2.18s-.49,4-3.78,4.7-6.93-.28-8.14-2.18S282.62,304,285.91,303.26Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,304.13a6.42,6.42,0,0,1,1.3-.16,5.76,5.76,0,0,1,1.2.08,3.21,3.21,0,0,1,.95.3,1.38,1.38,0,0,1,.6.5.67.67,0,0,1,.13.46.91.91,0,0,1-.14.41,2.1,2.1,0,0,1-.31.37l-.35.34a2.73,2.73,0,0,0-.28.33.42.42,0,0,0-.09.33.19.19,0,0,1,0,.15.24.24,0,0,1-.17.1l-1.44.3a.53.53,0,0,1-.25,0,.31.31,0,0,1-.18-.11.56.56,0,0,1-.09-.44,1,1,0,0,1,.19-.4,2,2,0,0,1,.34-.38l.36-.34a1.62,1.62,0,0,0,.25-.31.28.28,0,0,0,0-.29.67.67,0,0,0-.46-.25,2.29,2.29,0,0,0-.87.06,1.85,1.85,0,0,0-.7.25.53.53,0,0,0-.2.27,1.4,1.4,0,0,0-.06.24q0,.1-.24.15l-1.44.31a.67.67,0,0,1-.2,0,.24.24,0,0,1-.15-.1.76.76,0,0,1-.08-.54,1.3,1.3,0,0,1,.33-.62,2.84,2.84,0,0,1,.79-.58A5,5,0,0,1,286.75,304.13Zm4,4.41a.12.12,0,0,1,0,.15.29.29,0,0,1-.19.1l-1.48.32a.57.57,0,0,1-.26,0,.29.29,0,0,1-.18-.11l-.43-.68a.12.12,0,0,1,0-.15.27.27,0,0,1,.19-.1l1.48-.32a.57.57,0,0,1,.26,0,.27.27,0,0,1,.17.11Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-token--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.11,366.25a9.62,9.62,0,0,0,8.71,0c2.41-1.39,2.41-3.64,0-5a9.62,9.62,0,0,0-8.71,0C279.7,362.61,279.7,364.86,282.11,366.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,360.39a8.3,8.3,0,0,0-7.49,0,2.62,2.62,0,0,0-1.55,2.16v1a2.62,2.62,0,0,0,1.55,2.16,8.3,8.3,0,0,0,7.49,0,2.64,2.64,0,0,0,1.55-2.16v-1A2.64,2.64,0,0,0,290.21,360.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,364.72a8.3,8.3,0,0,0,7.49,0c2.07-1.2,2.07-3.14,0-4.33a8.3,8.3,0,0,0-7.49,0C280.65,361.58,280.65,363.52,282.72,364.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.24,363.86a6.94,6.94,0,0,0,6.45,0c1.79-1.05,1.79-2.77,0-3.82a6.94,6.94,0,0,0-6.45,0C281.45,361.09,281.45,362.81,283.24,363.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,361.53h0c0-1.74-1.82-5.33-1.82-10.67h-5.23c0,5.32-1.8,8.91-1.82,10.65a2.2,2.2,0,0,0,1.3,1.83,6.93,6.93,0,0,0,6.27,0,2.21,2.21,0,0,0,1.3-1.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,362.88c-.89-.74-1.05-1.87-.33-4.52a35.21,35.21,0,0,0,1-7.5h-1.8c0,5.32-1.8,8.91-1.82,10.65a2.2,2.2,0,0,0,1.3,1.83,6.93,6.93,0,0,0,6.27,0l.35-.23C288.33,363.84,285.84,363.61,285,362.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.62,352a4.07,4.07,0,0,0,3.69,0,1.12,1.12,0,0,0,0-2.13,4.07,4.07,0,0,0-3.69,0A1.12,1.12,0,0,0,284.62,352Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.46,
    cy: 350.39,
    rx: 2.12,
    ry: 1.22,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.28,348.21a2.82,2.82,0,1,1-2.82-2.82A2.81,2.81,0,0,1,289.28,348.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.23,348.76a2.87,2.87,0,0,1-3.49,1.38,2.81,2.81,0,0,1-1.61-3.51,2.82,2.82,0,1,0,5.1,2.13Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--white-token--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.71,340.1a9.62,9.62,0,0,0,8.71,0c2.41-1.39,2.41-3.64,0-5a9.62,9.62,0,0,0-8.71,0C302.3,336.46,302.3,338.71,304.71,340.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.81,334.33a8.3,8.3,0,0,0-7.49,0,2.62,2.62,0,0,0-1.55,2.16v1a2.62,2.62,0,0,0,1.55,2.16,8.3,8.3,0,0,0,7.49,0,2.64,2.64,0,0,0,1.55-2.16v-1A2.64,2.64,0,0,0,312.81,334.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.32,338.66a8.3,8.3,0,0,0,7.49,0c2.07-1.19,2.07-3.13,0-4.33a8.3,8.3,0,0,0-7.49,0C303.25,335.53,303.25,337.47,305.32,338.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.06,
    cy: 335.89,
    rx: 4.57,
    ry: 2.71,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,335.48h0c0-1.75-1.82-5.34-1.82-10.67h-5.23c0,5.31-1.81,8.9-1.82,10.65a2.21,2.21,0,0,0,1.3,1.83,7,7,0,0,0,6.27,0,2.22,2.22,0,0,0,1.3-1.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,336.82c-.89-.74-1.05-1.87-.33-4.51a36,36,0,0,0,1-7.5h-1.8c0,5.31-1.81,8.9-1.82,10.65a2.21,2.21,0,0,0,1.3,1.83,7,7,0,0,0,6.27,0l.35-.23C310.93,337.79,308.44,337.56,307.55,336.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.06,
    cy: 324.84,
    rx: 2.61,
    ry: 1.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.06,
    cy: 324.33,
    rx: 2.12,
    ry: 1.22,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,322.15a2.82,2.82,0,1,1-2.82-2.82A2.82,2.82,0,0,1,311.88,322.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,322.71a2.87,2.87,0,0,1-3.48,1.38,2.83,2.83,0,0,1-1.61-3.52,2.86,2.86,0,0,0-.48,1.58,2.81,2.81,0,0,0,5.57.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Food--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Soda--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M436.17,304.78c-4.84,2.79-4.84,7.32,0,10.11s12.66,2.79,17.49,0,4.84-7.32,0-10.11S441,302,436.17,304.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffe--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.68,276.14l-25.59,0,2.61,33.63h0c.11,1.23,1.07,2.44,2.91,3.37,3.9,2,10.35,2,14.39,0,1.9-.93,2.89-2.14,3-3.37h0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.87,271.76c-5.08-2.42-13.18-2.42-18.1,0s-4.91,6.34,0,8.76,13,2.42,18.1,0S459,274.18,453.87,271.76Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M453.87,271.76c-5.08-2.42-13.18-2.42-18.1,0s-4.91,6.34,0,8.76,13,2.42,18.1,0S459,274.18,453.87,271.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M433.92,279.35a9.81,9.81,0,0,0,1.85,1.17c4.92,2.42,13,2.42,18.1,0a10.37,10.37,0,0,0,1.92-1.17,8.92,8.92,0,0,0-2.28-1.5c-4.88-2.32-12.66-2.32-17.37,0A8.86,8.86,0,0,0,433.92,279.35Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--soda--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M111.82,345.54c-4.83,2.79-4.83,7.32,0,10.11s12.67,2.79,17.5,0,4.83-7.32,0-10.11S116.65,342.75,111.82,345.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffe--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.37,316.93l-25.59,0,2.61,33.63h0c.12,1.23,1.08,2.44,2.91,3.37,3.91,2,10.36,2,14.4,0,1.9-.93,2.89-2.14,3-3.37h0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.37,316.93l-25.59,0,2.61,33.63h0c.12,1.23,1.08,2.44,2.91,3.37,3.91,2,10.36,2,14.4,0,1.9-.93,2.89-2.14,3-3.37h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.56,312.55c-5.09-2.42-13.19-2.42-18.1,0s-4.91,6.34,0,8.76,13,2.42,18.1,0S134.64,315,129.56,312.55Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.56,312.55c-5.09-2.42-13.19-2.42-18.1,0s-4.91,6.34,0,8.76,13,2.42,18.1,0S134.64,315,129.56,312.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.56,312.55c-5.09-2.42-13.19-2.42-18.1,0s-4.91,6.34,0,8.76,13,2.42,18.1,0S134.64,315,129.56,312.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,320.14a9.5,9.5,0,0,0,1.85,1.17c4.91,2.42,13,2.42,18.1,0a9.87,9.87,0,0,0,1.92-1.18,9.37,9.37,0,0,0-2.28-1.49c-4.88-2.32-12.66-2.32-17.37,0A8.68,8.68,0,0,0,109.61,320.14Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pizza--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M377,336.79c-22.25,12.85-22.25,33.67,0,46.51s58.31,12.85,80.56,0,22.24-33.66,0-46.51S399.27,324,377,336.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plate--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.42,334.14c-21.82-12.59-57.19-12.59-79,0h0v-2.27c-11.41,6.59-16.84,15.32-16.32,23.95-.52,8.63,4.91,17.35,16.31,23.94,21.82,12.6,57.2,12.6,79,0S478.24,346.74,456.42,334.14Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.42,331.88c21.82,12.59,21.81,33,0,45.61s-57.2,12.6-79,0-21.81-33,0-45.62S434.6,319.28,456.42,331.88Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.42,331.88c21.82,12.59,21.81,33,0,45.61s-57.2,12.6-79,0-21.81-33,0-45.62S434.6,319.28,456.42,331.88Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,336.26c-15,8.66-15,22.69,0,31.35s39.31,8.66,54.3,0,15-22.69,0-31.35S405.12,327.6,390.12,336.26Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,336.26c-15,8.66-15,22.69,0,31.35s39.31,8.66,54.3,0,15-22.69,0-31.35S405.12,327.6,390.12,336.26Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,337.33c-14,8.07-14,21.15,0,29.21s36.63,8.07,50.6,0,14-21.14,0-29.21S405.94,329.26,392,337.33Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,337.33c-14,8.07-14,21.15,0,29.21s36.63,8.07,50.6,0,14-21.14,0-29.21S405.94,329.26,392,337.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.31,353.24c-.61,4.58,1.41,9.06,3.38,13.25a10.14,10.14,0,0,0,5.57,6l7,3.89a5,5,0,0,0,2.11.79c1.51.09,2.6-1.3,3.84-2.16,9.54-6.67,29.27-18.78,29.27-18.78s.5,2.7.64,3.59q.75,4.77,1.18,9.59c.29,3.28.4,6.86-1.49,9.56-.72,1-1.75,2-1.91,3.22a3.53,3.53,0,0,0,2.41,3.42,10.24,10.24,0,0,0,4.45.36,59.14,59.14,0,0,0,8.6-1c6.66-1.44,12.58-5.12,18.35-8.74-1.81-2-4.41-3-6.87-4.1a83.31,83.31,0,0,1-20.89-14c8.55.52,26.93,1.63,39.28,1.42a6.72,6.72,0,0,0,3.26-.82,3.44,3.44,0,0,0,1.67-4.42,8.18,8.18,0,0,0-1.62-2.31l-10.71-12a23.24,23.24,0,0,0-3.84-3.71,23.94,23.94,0,0,0-5.7-2.73c-6.25-2.33-12.71-4.71-19.38-4.49a2.55,2.55,0,0,0-1.23.27,2.41,2.41,0,0,0-.86,1.5c-2,7.27,0,15.3-2.71,22.31a2.47,2.47,0,0,1-1,1.4c-.6.3-1.52-.3-2.16-.5-6.34-2-12.47-3.59-18.81-5.58a40.43,40.43,0,0,1-7.17-2.77c-2.43-1.31-4.58-3.12-7.12-4.22C376.14,338.12,367.33,345.66,366.31,353.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,354,417,356a65.56,65.56,0,0,0,9.25.7c5.92.11,31.72,1.08,32.95.28,2-1.27-.41-4.24-.41-4.24H417.92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,364.88c.94-.59,8-4.78,8.92-5.38,1.5-1,3-1.95,4.42-3,.55-.42,1-.83.48-2.51a9.37,9.37,0,0,0-1.69-.44,12.23,12.23,0,0,0-5.5.76c-3.88,1.25-7.57,3-11.35,4.49a40.81,40.81,0,0,0-8.25,3.85,34.49,34.49,0,0,0-4.57,4,5.56,5.56,0,0,0-1.92,3c-.23,1.69.57,4.41,2.27,4.64A143.2,143.2,0,0,0,399.33,364.88Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.86,335.48a4.52,4.52,0,0,1,4-.14,7.6,7.6,0,0,1,2.52,1.89c1,1.15,2.31,1.08,5.23,3.15a7.28,7.28,0,0,1,3.34,4.38c.46.95.16,2.18.5,3.19s1.3,1.8,1.78,2.8a4.48,4.48,0,0,1,.41,3,2.77,2.77,0,0,1-2.1,2.07c-.34.06-.68,0-1,.12a6,6,0,0,0-1.16.59c-.86.44-2.13,1-3,.5-1-.58-1.21-1.5-1.21-3-.43-1.17-1.68-2.34-2.41-3.35l-4.26-5.92c-.33-.47-5.35-7.6-5.42-7.55Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,347.24c.21.31.43.61.65.91.51.71,1,1.43,1.54,2.14.15.22.3.43.46.63l.05.06a4.16,4.16,0,0,0,.58.61,2.26,2.26,0,0,1,.73,1,5.79,5.79,0,0,1,.88,1.46c0,1.5.19,2.42,1.21,3,.84.48,2.11-.06,3-.5a6,6,0,0,1,1.16-.59c.33-.08.67-.06,1-.12a2.77,2.77,0,0,0,2.1-2.07,4.48,4.48,0,0,0-.41-3,8.72,8.72,0,0,0-.91-1.36,1.93,1.93,0,0,1-.47,2.19c-.77.49-3.23.22-4.24-.31s-.61-2.18-.92-2.94-1.77-1.33-1.5-2.93-.74-2.85-3.07-3.63S452.44,340,451.5,339s-3.53-1.37-5.4-1.72c.07-.05,5.08,7.07,5.42,7.54C452.11,345.6,452.71,346.42,453.3,347.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,337.23a31.89,31.89,0,0,1,6.67,5l.08.09.26.27h0c3.23,3.39,5.07,7.29,5.07,11.43H416.93l2.93-1.69,1.07-.62.14-.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,337.23a31.89,31.89,0,0,1,6.67,5l.08.09.26.27h0c3.23,3.39,5.07,7.29,5.07,11.43H416.93l2.93-1.69,1.07-.62.14-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.74,327.9c-.08-.89,1.1-1.65,2.65-1.73a16.73,16.73,0,0,1,4.1.31c2.13.39,2.95-.18,7.57.1a14.9,14.9,0,0,1,3.25.47c1,.32,2.09.53,3.21.76a8.6,8.6,0,0,1,.88.19c2.35.6,3.48,2.17,5.86,2.73l.57.11c.2,0,.41,0,.62.05,3.07.07,5.35,3.47,4.09,4.19s-3.44,2.15-3.44,2.15l-29.18-7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,330.26c1.76-.52,4-1.35,5.94-1s3.39.91,6,.52a8.86,8.86,0,0,1,6.62,1.31c1.78,1.24,3.52,1.06,4.67,1.46s2.89,1.73,4.25,1.7,3.43-.85,3.38-1.51-1.57-1.57-3-1.92c.2,0,.41,0,.62.05,3.07.07,5.35,3.47,4.09,4.19s-3.44,2.15-3.44,2.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,330.26a70,70,0,0,1,10.88.84l.17,0,.52.09h0a52.94,52.94,0,0,1,17.6,6l-29.17,16.82v-3.27a.4.4,0,0,1,0-.11Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,330.26a70,70,0,0,1,10.88.84l.17,0,.52.09h0a52.94,52.94,0,0,1,17.6,6l-29.17,16.82v-3.27a.4.4,0,0,1,0-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.12,327.9c.07-.89-1.11-1.65-2.66-1.73a16.64,16.64,0,0,0-4.09.31c-2.14.39-3-.18-7.58.1a14.81,14.81,0,0,0-3.24.47c-1,.32-2.09.53-3.22.76a8.41,8.41,0,0,0-.87.19c-2.36.6-3.48,2.17-5.87,2.73l-.57.11a6,6,0,0,1-.62.05c-3.07.07-5.35,3.47-4.09,4.19s3.44,2.15,3.44,2.15l29.18-7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,330.26c-1.75-.52-4-1.35-5.94-1s-3.39.91-6,.52a8.88,8.88,0,0,0-6.62,1.31c-1.77,1.24-3.52,1.06-4.66,1.46s-2.89,1.73-4.25,1.7-3.44-.85-3.38-1.51,1.57-1.57,2.95-1.92a6,6,0,0,1-.62.05c-3.07.07-5.35,3.47-4.09,4.19s3.44,2.15,3.44,2.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,330.26a70.23,70.23,0,0,0-10.88.84l-.16,0-.52.09h0a53,53,0,0,0-17.6,6l29.18,16.82V330.26Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,330.26a70.23,70.23,0,0,0-10.88.84l-.16,0-.52.09h0a53,53,0,0,0-17.6,6l29.18,16.82V330.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,354.16c-1.56,0-3.63-.51-3.75-1.4s.83-1.69,1.28-2.49c.54-1,0-2,0-3a8.1,8.1,0,0,1,.15-1.39,1.93,1.93,0,0,1,.62-1.11,10.54,10.54,0,0,0,1.78-2.67,3.72,3.72,0,0,1,.51-.93c1-1.16,2.69-1.25,3.63-2.42a25.25,25.25,0,0,0,1.13-2.27,4.82,4.82,0,0,1,1.77-1.48,6.07,6.07,0,0,1,1.57-.68,5.44,5.44,0,0,1,1.51-.08,9,9,0,0,1,3.35.81,6.13,6.13,0,0,1,2.38,1.9c.25.35.15.41-.06.69l-1.16,1.62L382.14,345l-4.42,6.15c-.68,1-1.37,1.91-2.05,2.86Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,345l1.94-2.7,3.54-4.92c.1-.15.11-.25-.08-.51a6.06,6.06,0,0,0-2.38-1.9,9,9,0,0,0-3.35-.81,5.44,5.44,0,0,0-1.51.08,6.07,6.07,0,0,0-1.57.68,4.82,4.82,0,0,0-1.77,1.48,1.67,1.67,0,0,0-.12.23,8.77,8.77,0,0,1,2.24-1.19,3.82,3.82,0,0,1,3.21.25,1.63,1.63,0,0,1,.69.78,1.94,1.94,0,0,1-.2,1.5c-.66,1.35-2.07,1.68-3.1,2.65-.71.66-.38,1.66-2.53,2.68s-3,2.31-2.29,3.82-.25,2.33-.89,3.47.8,2.41,1.7,3.42c.68-.95,1.37-1.9,2.05-2.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.67,354.05a14.58,14.58,0,0,1,1.45-6.27l.05-.1a2.1,2.1,0,0,1,.15-.3h0c1.87-3.71,5.35-7.21,10.43-10.14l29.18,16.82H375.67Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.67,354.05a14.58,14.58,0,0,1,1.45-6.27l.05-.1a2.1,2.1,0,0,1,.15-.3h0c1.87-3.71,5.35-7.21,10.43-10.14l29.18,16.82H375.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,372.61a4.49,4.49,0,0,1-4,.14,7.35,7.35,0,0,1-2.52-1.88,9.91,9.91,0,0,0-2.81-1.67c-1.81-.93-3.13-1.9-3.68-3.28a7.75,7.75,0,0,0-1-2.13c-.53-.69-1.3-1.29-1.5-2.05s.05-1.59-.5-2.35a1.88,1.88,0,0,0-.27-.3,1.9,1.9,0,0,0-.38-.29c-2.08-1.31.34-4.75,2.12-4.75h5.2l12.08,16.82Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,365.12a6.47,6.47,0,0,0,3.15,5.5c.66.38,1.39.64,2,1.06,1.1.72,1.86,1.87,2.94,2.63a5.29,5.29,0,0,0,6,0,3.87,3.87,0,0,0,1.44-1.83,2.56,2.56,0,0,0-.25-2.27",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.75,370.87c-1.87-.35-4.45-.66-5.4-1.73s-1.27-2-3.61-2.81-3.34-2-3.07-3.63-1.2-2.18-1.51-2.94.08-2.4-.92-2.93-3.47-.8-4.24-.31a2,2,0,0,0-.27,2.57,1.9,1.9,0,0,0-.38-.29c-2.08-1.31.34-4.75,2.12-4.75h5.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.75,370.87a31.26,31.26,0,0,1-6.66-5l-.08-.08-.27-.28h0c-3.24-3.39-5.07-7.29-5.07-11.43h41.26L414,355.74l-1.08.62-.14.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.75,370.87a31.26,31.26,0,0,1-6.66-5l-.08-.08-.27-.28h0c-3.24-3.39-5.07-7.29-5.07-11.43h41.26L414,355.74l-1.08.62-.14.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.43,374a1.41,1.41,0,0,1,0,.2,3.8,3.8,0,0,1-2.86,3.37c-1.21.35-2.55.21-3.71.71s-2.22,1.88-3.6,2.22c-1.07.25-2.23-.14-3.29.14a16.29,16.29,0,0,0-2.06,1c-2.36,1-4.89-.55-7.22.42-.78.32-1.46.85-2.25,1.15a8.06,8.06,0,0,1-3,.36,20.21,20.21,0,0,1-4.39-.39,2.83,2.83,0,0,1-1-.38,2.53,2.53,0,0,1-1-2.09,4.12,4.12,0,0,1,.94-2.74,2.46,2.46,0,0,1,1.26-.45l1.75-.41,7.42-1.77,8.77-2.1,7.18-1.71c1.85-.45,3.87-1.23,5.61,0A3.32,3.32,0,0,1,450.43,374Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.11,374c1.83-.54,2.37-2,3-3.07l-.44.07-3.63.86-9.23,2.21L423,376.39l-3.21.76-1.21.29h0l-.26.06a2.46,2.46,0,0,0-1.26.45,4.12,4.12,0,0,0-.94,2.74,2.53,2.53,0,0,0,1,2.09,2.83,2.83,0,0,0,1,.38,20.21,20.21,0,0,0,4.39.39,8.06,8.06,0,0,0,3-.36,5.23,5.23,0,0,0,.72-.34,11.11,11.11,0,0,1-2,.22,4.46,4.46,0,0,1-1.55-.19,3.19,3.19,0,0,1-1.8-1.73,1.71,1.71,0,0,1,.91-1.92c.93-.57,3.78-.35,5.09-.53s2.31-1,5.09-.87,4.93-.42,6.3-1.76S441.26,374.52,443.11,374Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,370.87a47.41,47.41,0,0,1-8.72,3.84l-.14.05-.48.15h0a65,65,0,0,1-19.7,3l-.12-23.9,2.93,1.69,1.07.62.14.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,370.87a47.41,47.41,0,0,1-8.72,3.84l-.14.05-.48.15h0a65,65,0,0,1-19.7,3l-.12-23.9,2.93,1.69,1.07.62.14.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.5,331.21a52.94,52.94,0,0,1,17.6,6l-29.17,16.82v-2.39c.16.55,1.21,0,6.67-3.13,7.51-4.33,17.15-10.16,17.86-11.15S432.7,332,428.5,331.21Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,350.78V354c0-.17-2.28-18.37-3.54-20.91s-12.65-.94-12.93-.9q2.4-.6,4.89-1h0l.52-.09.16,0a70.23,70.23,0,0,1,10.88-.84v20.52Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,347.37c1.87-3.71,5.35-7.21,10.43-10.14l29.18,16.82h-4.14c.95-.1,0-.7-5.43-3.85-7.52-4.33-17.62-9.89-19.35-10.3S378.74,345,377.32,347.37Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.74,365.48c-3.24-3.39-5.07-7.29-5.07-11.43h41.26L414,355.74c.56-.46-.83-.51-8.56-.51-10.62,0-24.58.19-26.31.6S378.78,363.19,380.74,365.48Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.75,374.91a65,65,0,0,1-19.7,3l-.12-23.9,2.93,1.69c-.79-.33-.89.48-.89,4.93,0,6.13.34,14.17,1,15.17S432.78,376,436.75,374.91Z",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M433.29,346a3,3,0,0,1,1.24,1.21c.48,1,.06,2-1.24,2.77a7.63,7.63,0,0,1-6.9,0,2.33,2.33,0,0,1-1.42-2.08,2.46,2.46,0,0,1,1.42-1.9A7.69,7.69,0,0,1,433.29,346Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.82,360.38a3,3,0,0,1,1.24,1.21c.47,1,.06,2-1.24,2.77a7.63,7.63,0,0,1-6.9,0,2.37,2.37,0,0,1-1.43-2.09,2.47,2.47,0,0,1,1.43-1.89A7.63,7.63,0,0,1,423.82,360.38Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,343.69a8,8,0,0,1,2.37.34c1.51.46,2.55,1.38,2.58,2.44,0,1.55-2.11,2.83-4.81,2.85a7,7,0,0,1-3.59-.86,2.43,2.43,0,0,1-1.36-1.91C442,345,444.11,343.72,446.81,343.69Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.27,356.86a3,3,0,0,1-1.22-1.21c-.47-1,0-2,1.27-2.77a7.63,7.63,0,0,1,6.9,0,2.33,2.33,0,0,1,1.4,2.09,2.48,2.48,0,0,1-1.44,1.89A7.65,7.65,0,0,1,394.27,356.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.65,341.8a3.15,3.15,0,0,1,1.31,1.41c.47,1.09-.08,2.29-1.62,3.11a8.66,8.66,0,0,1-7.84-.18,2.55,2.55,0,0,1-1.45-2.41,3,3,0,0,1,1.76-2.11A8.66,8.66,0,0,1,393.65,341.8Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,333.69A3.27,3.27,0,0,1,410,335.1c.47,1.09-.09,2.3-1.62,3.11a8.66,8.66,0,0,1-7.84-.18,2.5,2.5,0,0,1-1.45-2.4,3,3,0,0,1,1.76-2.12A8.72,8.72,0,0,1,408.65,333.69Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,343.92a3.21,3.21,0,0,1,1.31,1.41c.46,1.09-.09,2.29-1.62,3.11a8.66,8.66,0,0,1-7.84-.18,2.54,2.54,0,0,1-1.46-2.41,3,3,0,0,1,1.77-2.11A8.66,8.66,0,0,1,412.77,343.92Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.11,333.54a7.65,7.65,0,0,1,2.36.33c1.52.46,2.56,1.38,2.59,2.44,0,1.55-2.11,2.83-4.81,2.85a6.94,6.94,0,0,1-3.59-.86,2.43,2.43,0,0,1-1.36-1.91C427.26,334.84,429.41,333.56,432.11,333.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.41,369.37a3.75,3.75,0,0,1,1.52-1.09,7.89,7.89,0,0,1,4.93-.31c2.46.63,3.55,2.3,2.44,3.72a4.81,4.81,0,0,1-2.88,1.5,8.14,8.14,0,0,1-3.57-.09C429.39,372.46,428.3,370.79,429.41,369.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,358.67a7.65,7.65,0,0,1,2.36.33c1.52.47,2.56,1.38,2.59,2.44,0,1.56-2.11,2.83-4.81,2.86a6.93,6.93,0,0,1-3.59-.87,2.4,2.4,0,0,1-1.36-1.9C381.87,360,384,358.69,386.72,358.67Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Popcorn--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M59.82,374.48c-12.56,7.25-12.56,19,0,26.26s32.92,7.25,45.48,0,12.56-19,0-26.26S72.38,367.23,59.82,374.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69,360.8a37.87,37.87,0,0,0,75.74,0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69,360.8a37.87,37.87,0,0,0,75.74,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78,345.34c-14.79,8.53-14.79,22.38,0,30.92s38.77,8.55,53.56,0,14.8-22.37,0-30.92S70.58,336.8,55.78,345.34Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,347.19c-13.57,7.51-13.58,19.7,0,27.22s35.57,7.53,49.15,0,13.57-19.71,0-27.23S71.56,339.67,58,347.19Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,347.19c-13.57,7.51-13.58,19.7,0,27.22s35.57,7.53,49.15,0,13.57-19.71,0-27.23S71.56,339.67,58,347.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,347.19c-13.57,7.51-13.58,19.7,0,27.22a35.61,35.61,0,0,0,3.28,1.6c0-.06,1.6-8.13,3.54-18.67,1.31-7.12,7.25-14,17.41-15.78C73.44,341.61,64.69,343.48,58,347.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64,358.34s0,0,0,0h0A.08.08,0,0,0,112.64,358.34Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.71,359.24a2.28,2.28,0,0,0,.51-1.44,2.32,2.32,0,0,0-4-1.62c0-.24,0-.47,0-.71a7.06,7.06,0,0,0-7.06-7.06,7.16,7.16,0,0,0-3.48.91,3.06,3.06,0,0,0-2.83-4.3,3.14,3.14,0,0,0-1.58.43,7.88,7.88,0,0,0,.09-1.09,8,8,0,0,0-15.1-3.66,2.78,2.78,0,0,0-5.11,0,6.27,6.27,0,0,0-11.6,3.3,4.73,4.73,0,0,0,.09.93,2.38,2.38,0,0,0-1.47-.53,2.33,2.33,0,0,0-2.32,2.33v0a5.56,5.56,0,0,0-8.3,4.06,3.32,3.32,0,0,0-1.23-.23,3.25,3.25,0,0,0-.44,0,.4.4,0,0,0-.15,0,1.75,1.75,0,0,0-.41.09,2.08,2.08,0,0,0-.3.13A4,4,0,0,0,49.9,354a1.27,1.27,0,0,0,0,.44,1.64,1.64,0,0,0,0,.22A2.33,2.33,0,0,0,50,355c0,.13.07.26.12.41l.08.2a4.17,4.17,0,0,0,1.12,1.53,5.38,5.38,0,0,0,.43.34,6.82,6.82,0,0,0-4.82,6.33c-.18,3.69,2.4,5.83,6.1,7.11a27.82,27.82,0,0,0,5.3,3.65c13.52,7.49,35.44,7.5,49,0a25.2,25.2,0,0,0,6.23-4.7c1.22-.26,3.69-.86,5.08-4.93A5.17,5.17,0,0,0,116.71,359.24Zm-4.07-.9s0,0,0,0h0A.08.08,0,0,0,112.64,358.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,369.9a25.2,25.2,0,0,1-6.23,4.7c-13.53,7.49-35.45,7.48-49,0a27.82,27.82,0,0,1-5.3-3.65c-4.23-.44-6.28-3.42-6.1-7.11a6.82,6.82,0,0,1,4.82-6.33,5.38,5.38,0,0,1-.43-.34,4.17,4.17,0,0,1-1.12-1.53l-.08-.2c-.05-.15-.09-.28-.12-.41a2.33,2.33,0,0,1-.06-.33,1.64,1.64,0,0,1,0-.22,1.27,1.27,0,0,1,0-.44,4,4,0,0,1,2.16-3.2,2.08,2.08,0,0,1,.3-.13,1.75,1.75,0,0,1,.41-.09.4.4,0,0,1,.15,0,3.25,3.25,0,0,1,.44,0,3.32,3.32,0,0,1,1.23.23A5.57,5.57,0,0,1,60.11,346c-3.44,1.8-3.92,8.4,2.8,9.34A3.18,3.18,0,0,0,64.23,358a4.43,4.43,0,0,0,3.31.34s-2.71,4.19.5,7.23A6.54,6.54,0,0,0,75,366.9s.16,3.47,2.36,4.64,3.39.14,3.49.06-.74,1.25,1.46,1.8a2.57,2.57,0,0,0,3.08-1.55s2.51,4.73,6.84,3.94a6.07,6.07,0,0,0,5-4.56,3,3,0,0,0,3,1.67c2.21-.16,2.61-2.78,2.61-2.78S106.74,374.41,113.5,369.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84,371.6a3.87,3.87,0,0,1-7-2.27,3.85,3.85,0,0,1,2.85-3.72,3.85,3.85,0,0,0,3.12,6.12A4.32,4.32,0,0,0,80.84,371.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,371.85a2.51,2.51,0,1,1-4.62-1.08,2.56,2.56,0,0,0,.64,1.41,2.53,2.53,0,0,0,4-.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,353.57a3.86,3.86,0,1,1-7.07,1.74,3.81,3.81,0,0,0,1.85,1.49,3.86,3.86,0,0,0,5-2.24A4,4,0,0,0,70,353.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,357.23a2.51,2.51,0,1,1-4.69.68,2.47,2.47,0,0,0,1.1,1.09,2.52,2.52,0,0,0,3.37-1.14A2.77,2.77,0,0,0,64,357.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,362.86a3.86,3.86,0,1,1-7-2,3.76,3.76,0,0,0,.87,2.22,3.87,3.87,0,0,0,5.43.53A3.83,3.83,0,0,0,104,362.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.14,361a2.51,2.51,0,1,1-4.62-1.08,2.52,2.52,0,0,0,4.19,1.59A2.91,2.91,0,0,0,108.14,361Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25,356.8a2.49,2.49,0,0,1,1.36,1.83,2.51,2.51,0,0,1-4.76,1.46,2.51,2.51,0,0,0,3.59-2.66A2.2,2.2,0,0,0,97.25,356.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.94,98.79l-3.51-6.59,2.82-8.14v-5l-8.63,5v5l3.71,6.43a.54.54,0,0,0,.26.22h0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,98.79l-3.51-6.59,2.82-8.14v-5l-8.63,5v5l3.71,6.43a.54.54,0,0,0,.26.22h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07,35.5A5.72,5.72,0,0,0,149.49,31l-2.11-1.22a5.76,5.76,0,0,0-5.18,0l-30,17.34a5.72,5.72,0,0,0-2.59,4.48V93.16a5.72,5.72,0,0,0,2.59,4.48l2.1,1.21a5.7,5.7,0,0,0,5.18,0L131,92.18l3.71,6.41a.55.55,0,0,0,1-.09l3.91-11.3,9.83-5.68A5.74,5.74,0,0,0,152.07,77Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59,93.16a5.72,5.72,0,0,0,2.59,4.48l2.1,1.21a5.79,5.79,0,0,0,4.74.21c-1.22.46-2.15-.23-2.15-1.7V55.82a5.32,5.32,0,0,1,.76-2.55l-7.28-4.2a5.29,5.29,0,0,0-.76,2.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,34.77c-.3-1.1-1.31-1.45-2.5-.76l-30,17.34a5.09,5.09,0,0,0-1.83,1.93l-7.27-4.2a5.22,5.22,0,0,1,1.82-1.93l30-17.35a5.76,5.76,0,0,1,5.18,0L149.49,31A5.73,5.73,0,0,1,152,34.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,49.81a8.05,8.05,0,0,1,3.22-1.13,4.1,4.1,0,0,1,4.38,2.55,8.37,8.37,0,0,1,.64,3.51,12.88,12.88,0,0,1-.37,3.17,18.51,18.51,0,0,1-.93,2.84,22.66,22.66,0,0,1-1.24,2.57c-.44.81-.88,1.6-1.29,2.37s-.8,1.55-1.13,2.32a9.48,9.48,0,0,0-.69,2.31,5,5,0,0,1-.29,1.06,1.35,1.35,0,0,1-.53.68l-3.73,2.15a.44.44,0,0,1-.58,0,1,1,0,0,1-.24-.75,10.78,10.78,0,0,1,.41-3,19.43,19.43,0,0,1,1-2.83c.41-.9.85-1.78,1.33-2.62s.92-1.64,1.33-2.39a18.18,18.18,0,0,0,1-2.17,5.19,5.19,0,0,0,.41-2c0-.91-.22-1.49-.67-1.75s-1.14-.12-2.07.42a5.31,5.31,0,0,0-2,1.77,7.9,7.9,0,0,0-.87,1.89c-.19.61-.35,1.16-.48,1.66a1.69,1.69,0,0,1-.78,1.09L126,65.66a.39.39,0,0,1-.47,0,.81.81,0,0,1-.2-.64A15.74,15.74,0,0,1,126,61.2a22.63,22.63,0,0,1,1.66-4.3,21.58,21.58,0,0,1,2.64-4A13.3,13.3,0,0,1,133.83,49.81Zm2.65,30.58a2.42,2.42,0,0,1-.24,1,1.59,1.59,0,0,1-.58.71l-3.85,2.22a.44.44,0,0,1-.58,0,1,1,0,0,1-.24-.75V78.81a2.42,2.42,0,0,1,.24-1,1.53,1.53,0,0,1,.58-.71l3.85-2.22a.44.44,0,0,1,.58,0,1,1,0,0,1,.24.75Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.42,97l3.51-6.59-2.82-8.14v-5l8.63,5v5L359,93.63a.52.52,0,0,1-.25.22h0Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.42,97l3.51-6.59-2.82-8.14v-5l8.63,5v5L359,93.63a.52.52,0,0,1-.25.22h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,47.06a5.71,5.71,0,0,1,2.59-4.48l2.1-1.22a5.76,5.76,0,0,1,5.18,0l41.16,23.77a5.72,5.72,0,0,1,2.58,4.48V94.84a5.72,5.72,0,0,1-2.58,4.48L380,100.54a5.76,5.76,0,0,1-5.18,0l-17.52-10.2-3.7,6.41a.55.55,0,0,1-1-.09l-3.92-11.3-15-8.58a5.74,5.74,0,0,1-2.59-4.49Z",
    style: {
      fill: "#FFA10B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,94.84a5.72,5.72,0,0,1-2.58,4.48L380,100.54a5.81,5.81,0,0,1-4.73.21c1.21.46,2.14-.23,2.14-1.71V73.81a5.29,5.29,0,0,0-.76-2.55l7.28-4.2a5.25,5.25,0,0,1,.76,2.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.18,46.33c.31-1.1,1.31-1.45,2.5-.76l41.17,23.76a5.15,5.15,0,0,1,1.82,1.93l7.28-4.2a5.17,5.17,0,0,0-1.83-1.93L341,41.36a5.76,5.76,0,0,0-5.18,0l-2.11,1.22A5.73,5.73,0,0,0,331.18,46.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.92,76.38a7.62,7.62,0,0,1,3.45,6c0,2.2-1.54,3.09-3.45,2a7.62,7.62,0,0,1-3.45-6C363.47,76.17,365,75.28,366.92,76.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.19,69a7.62,7.62,0,0,1,3.45,6c0,2.2-1.54,3.1-3.45,2a7.62,7.62,0,0,1-3.45-6C350.74,68.8,352.28,67.91,354.19,69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,61.65a7.62,7.62,0,0,1,3.45,6c0,2.2-1.54,3.09-3.45,2a7.62,7.62,0,0,1-3.45-6C338,61.44,339.55,60.55,341.46,61.65Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work-2.116463ea60ed50a5ba55cdd5c41d71e9.svg";
export { ForwardRef as ReactComponent };